
// Validation for the shipping address form shared by the promo-code checkout
// and the standalone "update shipping address" page.

export const REQUIRED_SHIPPING_FIELDS = ["firstName", "lastName", "addressLine1", "city", "state", "zipCode", "country"];

export const EMPTY_SHIPPING_DETAILS = {
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'US',
    phone: ''
};

const ZIP_CODE_REGEX = /^[A-Za-z0-9\s-]{3,10}$/;
const PHONE_REGEX = /^[\d\s\-().+]{7,20}$/;
const NO_SYMBOLS_FIELDS = ["firstName", "lastName", "city", "state"];
const NO_SYMBOLS_REGEX = /^[A-Za-z\s.,/\\'-]+$/;

export function validateShippingDetails(details, { requirePhone = false } = {}) {
    const errors = {};
    const requiredFields = requirePhone ? [...REQUIRED_SHIPPING_FIELDS, "phone"] : REQUIRED_SHIPPING_FIELDS;
    requiredFields.forEach((field) => {
        if (!details[field] || !details[field].trim()) {
            errors[field] = "This field is required.";
        }
    });
    if (!errors.zipCode && details.zipCode && !ZIP_CODE_REGEX.test(details.zipCode.trim())) {
        errors.zipCode = "Enter a valid zip code.";
    }
    if (!errors.phone && details.phone && !PHONE_REGEX.test(details.phone.trim())) {
        errors.phone = "Enter a valid phone number.";
    }
    NO_SYMBOLS_FIELDS.forEach((field) => {
        if (!errors[field] && details[field] && !NO_SYMBOLS_REGEX.test(details[field].trim())) {
            errors[field] = "No numbers or special characters allowed.";
        }
    });
    return errors;
}
